export const CUSTOMER_MAIN_DATA = {
  code: {
    label: '客户编码', // 必须
  },
  business: {
    label: '业务类型',
  },
  stdAccountPeriod: {
    label: '标准账期',
  },
  creditLevel: {
    label: '内部评级',
  },
  signDate: {
    label: '联想签约日期',
  },
  registerDate: {
    label: '公司注册日期',
  },
  region: {
    label: '大区',
  },
  registeredNo: {
    label: '工商注册号',
  },
  country: {
    label: '所在国家',
  },
  province: {
    label: '所在省份',
  },
  creditManager: {
    label: '信用主管',
  },
  isParent: {
    label: '公司类型',
    slotName: 'isParent',
  },
  defaultScoreType: {
    label: '默认评分卡',
  },
  insCoverRate: {
    label: '保险覆盖率',
  },
  source: {
    label: '客户来源',
    filter: value => {
      return value == 1 ? 'CRM' : 'Le-Credit'
    },
  },
}

export const CREDIT_LIMIT = {
  totalCreditLimit: {
    label: '已生效限额',
    slotName: 'totalCreditLimit',
  },
  limitControlAmount: {
    label: '限额条件',
  },
  creditLimitExposure: {
    label: '信用限额敞口',
  },
  earliestDate: {
    label: '最近额度到期日',
    slotName: 'earliestDate',
  },
  groupExposure: {
    label: '集团限额敞口',
  },
  normalAmount: {
    label: '当前有效正常额度',
  },
  tempAmount: {
    label: '当前有效临时额度',
  },
  specialAmount: {
    label: '当前有效专项额度',
  },
  validAmount: {
    label: '当前有效额度',
    slotName: 'validAmount',
  },
  groupTotalAmount: {
    label: '集团总额度',
  },
  onRoadLimit: {
    label: '申请中的信用限额',
  },
  onRoadNormal: {
    label: '申请中的正常额度',
  },
  onRoadTemp: {
    label: '申请中的临时额度',
  },
  onRoadSpecial: {
    label: '申请中的专项额度',
  },
}

export const columns = [
  {
    title: '逾期状态',
    dataIndex: 'id',
    width: '33%',
  },
  {
    title: '金额（RMB)',
    dataIndex: 'amount',
    width: '33%',
  },
  {
    title: '占比',
    dataIndex: 'rate',
    width: '33%',
  },
]
export const segments = [
  {
    title: '业务类型',
    dataIndex: 'businessName',
    width: '33%',
  },
  {
    title: 'segment',
    dataIndex: 'segment',
    width: '33%',
  },
  {
    title: '账期(天)',
    dataIndex: 'term',
    width: '33%',
  },
]
export const columnsIsParent = [
  {
    title: '公司ID',
    width: 200,
    dataIndex: 'code',
    align: 'center',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: '公司名称',
    width: 200,
    dataIndex: 'name',
    align: 'center',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '保险覆盖率',
    width: 200,
    dataIndex: 'insCoverRate',
    align: 'center',
    scopedSlots: { customRender: 'insCoverRate' },
  },
]
export const columnsIsParent2 = [
  {
    title: '公司ID',
    width: 200,
    dataIndex: 'code',
    align: 'center',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: '公司名称',
    width: 200,
    dataIndex: 'name',
    align: 'center',
    scopedSlots: { customRender: 'name' },
  },
]
export const columnsValidAmount = [
  {
    title: '业务模式',
    width: 200,
    dataIndex: 'mode',
    align: 'center',
  },
  {
    title: '金额',
    width: 200,
    dataIndex: 'amount',
    align: 'center',
  },
  {
    title: '货币',
    width: 120,
    dataIndex: 'moneyType',
    align: 'center',
  },
  {
    title: '占比（%）',
    width: 200,
    dataIndex: 'ratio',
    align: 'center',
  },
]

export const columnsValidLimitAmount = [
  {
    title: '限额',
    width: 200,
    dataIndex: 'amountLimitAmount',
    align: 'center',
  },
  {
    title: '到期日',
    width: 200,
    dataIndex: 'indateEnd',
    align: 'center',
  },
  {
    title: '币种',
    width: 200,
    dataIndex: 'moneyType',
    align: 'center',
  },
]
